import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import React, { Component } from "react";

export default class EditableTextFieldFacebook extends Component {
  constructor(props) {
    super(props);

    this.state = {
      disbaledField: false,
      value: this.props.value,
      urlStatus: "",
    };

    this.handleClickEdit = this.handleClickEdit.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.onDataCheck = this.onDataCheck.bind(this);
  }

  componentDidMount() {
    this.setState({
      value: this.props.value,
    });
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.value !== this.props.value) {
      this.setState({
        value: this.props.value,
      });
    }
  }

  handleClickEdit() {
    this.setState({
      disbaledField: false,
    });
    this.props.handleClickEdits();
  }

  onDataCheck(key) {
    this.props.onDataCheck(key);
    this.setState({
      urlStatus: key,
    });
  }

  handleChangeInput(event) {
    this.setState({
      value: event.target.value,
    });
    this.props.getSelectedValue(event.target.value);
    this.props.handleClickEdits();
  }

  render() {
    const { label } = this.props;
    const { disbaledField, value } = this.state;
    return (
      <div
        className={
          disbaledField
            ? "editableTextWrapper formFieldGroup disabledField"
            : "editableTextWrapper formFieldGroup"
        }
      >
        <label className="label-v2">{label}</label>
        <Grid container spacing={0} alignItems="flex-end" wrap="nowrap">
          <Grid item xs={12}>
            <TextField
              id="textField"
              label=""
              variant="outlined"
              style={{
                border:
                  this.state.urlStatus === "true"
                    ? "2px solid green"
                    : this.state.urlStatus === "false"
                    ? "2px solid red"
                    : "",
                borderRadius: "6px",
              }}
              onPasteCapture={(e) => {
                if (
                  !/^(https?:\/\/)?((w{3}\.)?)facebook.com\/.*/i.test(
                    e.target.value
                  )
                ) {
                  this.onDataCheck("false");
                } else {
                  this.onDataCheck("true");
                }
              }}
              onPaste={(e) => {
                if (
                  !/^(https?:\/\/)?((w{3}\.)?)facebook.com\/.*/i.test(
                    e.target.value
                  )
                ) {
                  this.onDataCheck("false");
                } else {
                  this.onDataCheck("true");
                }
              }}
              onKeyUp={(e) => {
                if (
                  !/^(https?:\/\/)?((w{3}\.)?)facebook.com\/.*/i.test(
                    e.target.value
                  )
                ) {
                  this.onDataCheck("false");
                } else {
                  this.onDataCheck("true");
                }
              }}
              onKeyPress={(e) => {
                if (
                  !/^(https?:\/\/)?((w{3}\.)?)facebook.com\/.*/i.test(
                    e.target.value
                  )
                ) {
                  this.onDataCheck("false");
                } else {
                  this.onDataCheck("true");
                }
              }}
              type="url"
              value={value}
              onChange={this.handleChangeInput}
              disabled={disbaledField}
              fullWidth={true}
            />
          </Grid>
        </Grid>
      </div>
    );
  }
}
